define('knockout-track-changes',['knockout', 'jquery'], function (ko, $) {

	ko.extenders.trackChange = function (target, track) {

		if (track) {
			target.originalValue = target();

			target.isDirty = ko.pureComputed(function () {
				return !target.equalityComparer(target(), target.originalValue);
			});

			target.setOriginalValue = function(startingValue) {
				target.originalValue = startingValue; 
			};

			target.revertToOriginal = function () {
				target(target.originalValue);
			}
		}

		return target;
	};

});
